import GiftGreenIcon from "@/assets/icons/snackbar_gift.svg"
import { TransitionSnackbarVariant, transitionSnackbarState } from "@/atoms/snackbarState"
import useTransitionSnackbar from "@/hooks/useTransitionSnackbar"
import { cn } from "@/utils/twMerge"
import { Box, Typography } from "@mui/material"
import Slide, { SlideProps } from "@mui/material/Slide"
import Snackbar from "@mui/material/Snackbar"
import { useAtomValue } from "jotai"
import Image from "next/image"

export function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction='up' />
}

const COLORS: { [key in TransitionSnackbarVariant]: string } = {
  success: "bg-green-mid-400 hover:bg-green-mid-500",
  error: "bg-red-400 hover:bg-red-500",
  warning: "bg-yellow-400 hover:bg-yellow-500",
  info: "bg-blue-400 hover:bg-blue-500",
}

export default function TransitionsSnackbar() {
  const state = useAtomValue(transitionSnackbarState)
  const { handleCloseSnackbar } = useTransitionSnackbar()

  const bgColor = COLORS[state.variant] ?? COLORS.success
  return (
    <Snackbar
      open={state.open}
      onClose={handleCloseSnackbar}
      TransitionComponent={state.Transition}
      key={state.Transition.name}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: state.vertical, horizontal: state.horizontal }}
    >
      <Box
        className={cn("flex gap-1 py-2 px-4 min-w-32 rounded-md font-semibold cursor-pointer", bgColor)}
        onClick={handleCloseSnackbar}
      >
        <Image src={GiftGreenIcon} alt='info-icon' width={16} height={16} />
        <Typography className='text-white text-sm shadow-sm'>{state.message}</Typography>
      </Box>
    </Snackbar>
  )
}
